import * as Web3 from 'web3';

let gameRoomContractABI;
let gameRoomContractAddress;

async function loadContract(networkVersion) {
	gameRoomContractABI = [
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "stateMutability": "payable",
            "type": "fallback"
        },
        {
            "inputs": [],
            "name": "balance",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "createUser",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "depositBalance",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "depositContract",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getBalance",
            "outputs": [
                {
                    "internalType": "int256",
                    "name": "",
                    "type": "int256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getExistance",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalBalanceSnapshot",
            "outputs": [
                {
                    "internalType": "int256",
                    "name": "",
                    "type": "int256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_amount",
                    "type": "uint256"
                },
                {
                    "internalType": "int256",
                    "name": "_tab",
                    "type": "int256"
                }
            ],
            "name": "withdrawBalance",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_amount",
                    "type": "uint256"
                }
            ],
            "name": "withdrawContract",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "stateMutability": "payable",
            "type": "receive"
        }
    ];
    if (networkVersion === '1') {
        gameRoomContractAddress = "0x8666ffc88698d2b3c557d5c39607952eff6a3743";
    } else if (networkVersion === '3') {
        gameRoomContractAddress = "0xa15fB82c7654C75a59655274e03b56bd7842A066";
    }
    console.log(gameRoomContractAddress, networkVersion);
	window.contract = await new window.web3.eth.Contract(gameRoomContractABI, gameRoomContractAddress);
}

async function createUser(address) {
    await window.contract.methods.createUser().send({ from: address });
}

async function getBalance(address) {
    try {
        return await window.contract.methods.getBalance().call({ from: address });
    } catch (error) {
        return error;
    }
}

async function getExistance(address) {
    return await window.contract.methods.getExistance().call({ from: address });
}

async function depositBalance(address, depositAmount) {
	await window.contract.methods.depositBalance().send({ from: address, value: Web3.utils.toWei(depositAmount, "ether") });
}

async function withdrawBalance(address, withdrawAmount, tab) {
	await window.contract.methods.withdrawBalance(Web3.utils.toWei(withdrawAmount, "ether"), Web3.utils.toWei(tab, "ether")).send({ from: address });
}

async function getLiquidity(address) {
    return await window.contract.methods.balance().call({ from: address });
}

async function withdrawFromContract(address, withdrawAmount) {
	await window.contract.methods.withdrawContract(Web3.utils.toWei(withdrawAmount, "ether")).send({ from: address });
}

async function depositToContract(address, depositAmount) {
    await window.contract.methods.depositContract().send({ from: address, value: Web3.utils.toWei(depositAmount, "ether") });
}

async function getContractBalanceSnapshot(address) {
    return await window.contract.methods.totalBalanceSnapshot().call({ from: address });
}

export {loadContract, createUser, getBalance, getExistance, depositBalance, withdrawBalance, getLiquidity, withdrawFromContract, getContractBalanceSnapshot, depositToContract};